// extracted by css-extract-rspack-plugin
export default {"Octicon":"BypassAvatar-module__Octicon__GQs0j"};